'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nl_BE = require('../../date-picker/locale/nl_BE');

var _nl_BE2 = _interopRequireDefault(_nl_BE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _nl_BE2['default'];